import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=12f7ec3e&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./layout.vue?vue&type=style&index=1&id=12f7ec3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f7ec3e",
  null
  
)

export default component.exports